import React, { ReactNode, useContext, useEffect, useMemo } from "react";
import { ConfigProvider } from "antd";
import { deepMergeTokens } from "@utils/themeUtils";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import { ConsumerTokens } from "@type/tokens";
import { DeepPartial } from "@type/utils";
import { EnigmaContext } from "./enigmaContext";
import { getAntdThemeConfig } from "./antdTokensAdapter";

export interface ThemeProviderProps {
    tokens?: DeepPartial<ConsumerTokens>;
    children: ReactNode;
    providerId?: string;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
    tokens = {},
    children,
    providerId = "default",
}) => {
    const currentConsumerTokens = useContext(EnigmaContext);

    const newConsumerTokens = useMemo(
        () => deepMergeTokens<ConsumerTokens>(currentConsumerTokens, tokens),
        [currentConsumerTokens, tokens]
    );

    const antdTheme = useMemo(
        () => getAntdThemeConfig(newConsumerTokens),
        [newConsumerTokens]
    );

    useEffect(() => {
        useEnigmaToken.setDesignToken(newConsumerTokens, providerId);
    }, [newConsumerTokens]);

    return (
        <EnigmaContext.Provider value={newConsumerTokens}>
            <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
        </EnigmaContext.Provider>
    );
};
